module.exports = __webpack_public_path__ + "static/centminmod-b932d6e6069600baa8cdd07af86d2236.png";